export const IconNames = {
  'aa-placeholder': 'aa-placeholder',
  'alarm': 'alarm',
  'alt-route': 'alt-route',
  'apps': 'apps',
  'arrow-bubble': 'arrow-bubble',
  'arrow-down': 'arrow-down',
  'arrow-drop-down': 'arrow-drop-down',
  'arrow-drop-up': 'arrow-drop-up',
  'arrow-left': 'arrow-left',
  'arrow-line-down': 'arrow-line-down',
  'arrow-line-left': 'arrow-line-left',
  'arrow-line-right': 'arrow-line-right',
  'arrow-line-up': 'arrow-line-up',
  'arrow-prompt': 'arrow-prompt',
  'arrow-redo': 'arrow-redo',
  'arrow-right': 'arrow-right',
  'arrow-square-in': 'arrow-square-in',
  'arrow-square-out': 'arrow-square-out',
  'arrow-undo': 'arrow-undo',
  'arrow-up': 'arrow-up',
  'arrows-down-up': 'arrows-down-up',
  'arrows-left-right': 'arrows-left-right',
  'asterisk': 'asterisk',
  'at': 'at',
  'attachment': 'attachment',
  'bank': 'bank',
  'barcode-reader': 'barcode-reader',
  'barcode': 'barcode',
  'barricade': 'barricade',
  'basket': 'basket',
  'bell-active': 'bell-active',
  'bell-slash': 'bell-slash',
  'bell': 'bell',
  'bin': 'bin',
  'blog-post': 'blog-post',
  'blueprint': 'blueprint',
  'book-a': 'book-a',
  'book': 'book',
  'bookmark-outlined': 'bookmark-outlined',
  'bookmark': 'bookmark',
  'bookmarks': 'bookmarks',
  'broadcast': 'broadcast',
  'Building': 'Building',
  'calendar-add': 'calendar-add',
  'calendar-view-day': 'calendar-view-day',
  'calendar-view-month': 'calendar-view-month',
  'calendar-view-week': 'calendar-view-week',
  'calendar': 'calendar',
  'caret-down': 'caret-down',
  'caret-left': 'caret-left',
  'caret-right': 'caret-right',
  'caret-up': 'caret-up',
  'cart': 'cart',
  'certificate': 'certificate',
  'check-all': 'check-all',
  'check-thick': 'check-thick',
  'check': 'check',
  'checkbox-checked': 'checkbox-checked',
  'checkbox-focus': 'checkbox-focus',
  'checkbox-indeterminate': 'checkbox-indeterminate',
  'checkbox': 'checkbox',
  'circle-change': 'circle-change',
  'circle-check': 'circle-check',
  'circle': 'circle',
  'circles-add': 'circles-add',
  'circuit': 'circuit',
  'clipboard': 'clipboard',
  'clock-countdown': 'clock-countdown',
  'clock': 'clock',
  'cloud-synced': 'cloud-synced',
  'code': 'code',
  'color': 'color',
  'compass': 'compass',
  'cone': 'cone',
  'confetti': 'confetti',
  'copy': 'copy',
  'credit-card': 'credit-card',
  'cube-focus': 'cube-focus',
  'cursor-click': 'cursor-click',
  'cursor': 'cursor',
  'cut': 'cut',
  'data-object': 'data-object',
  'database': 'database',
  'devices': 'devices',
  'dictionary': 'dictionary',
  'dna': 'dna',
  'donut': 'donut',
  'dot': 'dot',
  'dots': 'dots',
  'download-cloud': 'download-cloud',
  'download': 'download',
  'edit': 'edit',
  'encrypted': 'encrypted',
  'envelope': 'envelope',
  'equal': 'equal',
  'eraser': 'eraser',
  'error': 'error',
  'event-list': 'event-list',
  'export': 'export',
  'extension': 'extension',
  'eye-slash': 'eye-slash',
  'eye': 'eye',
  'faq': 'faq',
  'file-add': 'file-add',
  'file': 'file',
  'files': 'files',
  'filter-remove': 'filter-remove',
  'filter': 'filter',
  'finish': 'finish',
  'fit-screen': 'fit-screen',
  'flag-checkered': 'flag-checkered',
  'flag': 'flag',
  'forklift': 'forklift',
  'fullscreen-exit': 'fullscreen-exit',
  'fullscreen': 'fullscreen',
  'garage': 'garage',
  'gauge': 'gauge',
  'globe-grid': 'globe-grid',
  'globe': 'globe',
  'gripper': 'gripper',
  'handle-vertical': 'handle-vertical',
  'handle': 'handle',
  'hash': 'hash',
  'heart-outlined': 'heart-outlined',
  'heart': 'heart',
  'help': 'help',
  'history': 'history',
  'home': 'home',
  'image': 'image',
  'images': 'images',
  'inbox': 'inbox',
  'infinity': 'infinity',
  'info': 'info',
  'inventory': 'inventory',
  'invoice': 'invoice',
  'jump-back': 'jump-back',
  'jump-forward': 'jump-forward',
  'kanban': 'kanban',
  'kbd-backspace': 'kbd-backspace',
  'kbd-capslock': 'kbd-capslock',
  'kbd-command': 'kbd-command',
  'kbd-control': 'kbd-control',
  'kbd-hide': 'kbd-hide',
  'kbd-option': 'kbd-option',
  'kbd-return': 'kbd-return',
  'kbd-shift': 'kbd-shift',
  'kbd-space': 'kbd-space',
  'kbd': 'kbd',
  'lightning': 'lightning',
  'line-segment': 'line-segment',
  'line-segments': 'line-segments',
  'link-slash': 'link-slash',
  'link': 'link',
  'linked-services': 'linked-services',
  'list-bullets': 'list-bullets',
  'list-checks': 'list-checks',
  'list-numbers': 'list-numbers',
  'lock-open': 'lock-open',
  'lock': 'lock',
  'map-pin': 'map-pin',
  'map': 'map',
  'mark-unread': 'mark-unread',
  'menu-close': 'menu-close',
  'menu': 'menu',
  'message': 'message',
  'messages': 'messages',
  'minus-thick': 'minus-thick',
  'minus': 'minus',
  'money': 'money',
  'monitor': 'monitor',
  'moon': 'moon',
  'navigation': 'navigation',
  'network-x': 'network-x',
  'network': 'network',
  'newspaper-clipping': 'newspaper-clipping',
  'newspaper': 'newspaper',
  'note-stack': 'note-stack',
  'note': 'note',
  'notepad': 'notepad',
  'notification': 'notification',
  'nut': 'nut',
  'order': 'order',
  'package': 'package',
  'page-first': 'page-first',
  'page-last': 'page-last',
  'parts': 'parts',
  'password': 'password',
  'path': 'path',
  'pause': 'pause',
  'pencil': 'pencil',
  'percent': 'percent',
  'play-pause': 'play-pause',
  'play': 'play',
  'plus': 'plus',
  'printer': 'printer',
  'prohibit': 'prohibit',
  'question-mark': 'question-mark',
  'quote': 'quote',
  'radio-checked': 'radio-checked',
  'radio-focus': 'radio-focus',
  'radio': 'radio',
  'read-doc': 'read-doc',
  'receipt': 'receipt',
  'recycle': 'recycle',
  'refresh': 'refresh',
  'repeat': 'repeat',
  'reply-all': 'reply-all',
  'reply': 'reply',
  'resize': 'resize',
  'ribbon': 'ribbon',
  'rows-add': 'rows-add',
  'ruler': 'ruler',
  'rules': 'rules',
  'scale': 'scale',
  'schedule-backward': 'schedule-backward',
  'schedule-forward': 'schedule-forward',
  'screwdriver': 'screwdriver',
  'scroll': 'scroll',
  'search-check': 'search-check',
  'search-items': 'search-items',
  'search-objects': 'search-objects',
  'search': 'search',
  'send': 'send',
  'settings': 'settings',
  'shapes': 'shapes',
  'share': 'share',
  'shuffle': 'shuffle',
  'signpost': 'signpost',
  'skip-back': 'skip-back',
  'skip-forward': 'skip-forward',
  'skull': 'skull',
  'sliders': 'sliders',
  'sort-alpha-down': 'sort-alpha-down',
  'sort-alpha-up': 'sort-alpha-up',
  'sort-ascending': 'sort-ascending',
  'sort-descending': 'sort-descending',
  'sort-time-down': 'sort-time-down',
  'sort-time-up': 'sort-time-up',
  'square-add': 'square-add',
  'square-inside': 'square-inside',
  'square-select': 'square-select',
  'square': 'square',
  'stamp': 'stamp',
  'star-outlined': 'star-outlined',
  'star': 'star',
  'start': 'start',
  'step': 'step',
  'stop': 'stop',
  'story': 'story',
  'strategy': 'strategy',
  'success': 'success',
  'sun': 'sun',
  'support': 'support',
  'sync': 'sync',
  'tag': 'tag',
  'target-2': 'target-2',
  'target': 'target',
  'task-alt': 'task-alt',
  'text-add': 'text-add',
  'textbox': 'textbox',
  'time-add': 'time-add',
  'timer': 'timer',
  'toolbox': 'toolbox',
  'tools': 'tools',
  'trash': 'trash',
  'trophy': 'trophy',
  'truck-trailer': 'truck-trailer',
  'update': 'update',
  'upload-cloud': 'upload-cloud',
  'upload': 'upload',
  'user-add': 'user-add',
  'user-details': 'user-details',
  'user-group': 'user-group',
  'user-id-badge': 'user-id-badge',
  'user-id-card': 'user-id-card',
  'user-recent': 'user-recent',
  'user': 'user',
  'verified': 'verified',
  'video': 'video',
  'view-cards': 'view-cards',
  'view-doc': 'view-doc',
  'view-grid': 'view-grid',
  'view-rows': 'view-rows',
  'view-table': 'view-table',
  'wand': 'wand',
  'warning': 'warning',
  'weight': 'weight',
  'widgets': 'widgets',
  'work-order': 'work-order',
  'wrench-2': 'wrench-2',
  'wrench': 'wrench',
  'x': 'x',
  'zoom-in': 'zoom-in',
  'zoom-out': 'zoom-out'
} as const;